import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';

import './vdp-certified-pre-owned-card.scss';

export function VdpCertifiedPreOwnedCard({ title, make, content, isCollapsible = false, contentCollapseClasses = '' }) {
  return (
    <VdpModule
      className="bg-white vdp-certified-pre-owned-card"
      contentCollapseClasses={classnames('vdp-certified-pre-owned-card', contentCollapseClasses)}
      collapseConfig={
        isCollapsible ? { minHeight: '394px', scrollOffset: -90, btnTrackingId: 'view_more_info' } : undefined
      }
      collapseGradientClassName="vdp-certified-pre-owned-card-collapse-gradient"
      titleClassName="vdp-certified-pre-owned-card-title d-flex heading-4 text-capitalize"
      headerTag="h3"
      sectionTitle={
        <>
          <img
            className="vdp-certified-pre-owned-card-image  me-0_5"
            src={getStaticImageUrl(`/img/oem-logos/75x75/${makeNiceName(make)}-cpo.png`)}
            loading="lazy"
            alt=""
          />
          {title}
        </>
      }
    >
      <ContentFragment>{content}</ContentFragment>
    </VdpModule>
  );
}

VdpCertifiedPreOwnedCard.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  isCollapsible: PropTypes.bool,
  contentCollapseClasses: PropTypes.string,
};
